import native from '../assets/roasters/native.png';
import heart from '../assets/roasters/heart.png';
import littlewolf from '../assets/roasters/littlewolf.png';
import outerdark from '../assets/roasters/outerdark.png';
import moxie from '../assets/roasters/moxie.png';
import dorothea from '../assets/roasters/dorothea.png';
import gloom from '../assets/roasters/gloom.png';
import makeworth from '../assets/roasters/makeworth.png';
import passenger from '../assets/roasters/passenger.png';
import kuma from '../assets/roasters/kuma.png';
import ilse from '../assets/roasters/ilse.png';
import sweetbloom from '../assets/roasters/sweetbloom.png';

/**
 * Roasters who've had the bar before, most recent first. Logos are each
 * roaster's own mark, set in white for the dark page; each tile links to the
 * roaster's site and says where they roast. Add the new one to the top when a
 * roaster rotates off; the page hides whoever is pouring now.
 *
 * Sites and cities were checked on each roaster's own site (October 2026).
 *
 * `size` tunes how big a mark sits in its tile: wordmarks are wide and short,
 * icons are square. `label` prints the name under marks that are icon only.
 */
export interface PastRoaster {
  name: string;
  logo: string;
  url: string;
  location: string;
  size?: 'wide' | 'thin' | 'icon' | 'round';
  label?: boolean;
}

export const PAST_ROASTERS: PastRoaster[] = [
  // Native's wordmark is NA⊥IVE with the T upside down, as on their bags
  { name: 'Native', logo: native, url: 'https://www.thenativecoffeecompany.com/', location: 'Popayán, Colombia', size: 'thin' },
  { name: 'Heart', logo: heart, url: 'https://www.heartroasters.com/', location: 'Portland, OR', size: 'round' },
  { name: 'Little Wolf', logo: littlewolf, url: 'https://littlewolf.coffee/', location: 'Ipswich, MA', size: 'wide' },
  { name: 'Outer Dark', logo: outerdark, url: 'https://www.outerdarkcoffee.com/', location: 'Tacoma, WA', size: 'wide' },
  { name: 'Moxie', logo: moxie, url: 'https://moxiecoffeeco.com/', location: 'Phoenix, AZ', size: 'icon', label: true },
  { name: 'Dorothea', logo: dorothea, url: 'https://dorotheacoffee.com/', location: 'Mount Vernon, WA', size: 'wide' },
  { name: 'Gloom', logo: gloom, url: 'https://gloom.coffee/', location: 'Seattle, WA', size: 'icon' },
  { name: 'Makeworth', logo: makeworth, url: 'https://makeworthcoffee.com/', location: 'Bellingham, WA', size: 'wide' },
  { name: 'Passenger', logo: passenger, url: 'https://drinkpassenger.com/', location: 'Lancaster, PA', size: 'icon', label: true },
  { name: 'Kuma', logo: kuma, url: 'https://www.kumacoffee.com/', location: 'Seattle, WA', size: 'icon' },
  { name: 'ilse', logo: ilse, url: 'https://ilsecoffee.com/', location: 'North Canaan, CT', size: 'icon' },
  { name: 'Sweet Bloom', logo: sweetbloom, url: 'https://sweetbloomcoffee.com/', location: 'Lakewood, CO', size: 'thin' },
];

/**
 * Roasters' own sites, by the first word of their name, for linking whoever is
 * pouring now. The coffee board doesn't carry a site, so a new roaster gets
 * its line here (and its tile above once it rotates off).
 */
const SITES: Record<string, string> = {
  naomi: 'https://naomijoecoffee.com/',
  ...Object.fromEntries(PAST_ROASTERS.map((roaster) => [roaster.name.split(' ')[0].toLowerCase(), roaster.url])),
};

export const roasterSite = (name?: string) => (name ? SITES[name.split(' ')[0].toLowerCase()] : undefined);
